import { useEffect, useState } from "react";

//"Custom Hook" die die Texte aus der gno_text.json fetched
// wird in App aufgerufen und dann an Komponenten verteilt
export const useText = () => {
  const [text, setText] = useState("")

  useEffect(() => {
    let isMounted = true;

    fetch(`${process.env.REACT_APP_MY_JSON_URL}`).then(
      function(res){
      return res.json()
      })
      .then(function(data: any){
          if(isMounted){setText(data)} 
      })
      .catch(function(err){
        console.log(err, 'GNO Text nicht vorhanden')
      }
  )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return () => {
    isMounted = false;
  }
  }, [])

  return text
}
